LS.util.route({
	'contact': {
		':load': 'contact',
		':unload': 'contact:unload'
	}
});